/* 2009-2018 Copyright Ridecell Inc. All rights reserved. */
import document from './util/document'
import window from './util/window'

const downloadResponseAsync =
  Object.keys(document).length > 0
    ? async (response, filename = '') => {
        const blobUrl = window.URL.createObjectURL(await response.blob())
        const a = document.createElement('a')
        a.setAttribute('href', blobUrl)
        a.setAttribute('download', filename)
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      }
    : async () => {
        // eslint-disable-next-line no-console
        console.error('This feature is available for web environment only.')
      }

export default downloadResponseAsync
